package com.sddamico.swigmore.models

import kotlinx.serialization.Serializable

/** A null key means push is off on this server, so clients skip the opt-in. */
@Serializable
data class VapidKeyResponse(val publicKey: String?)

@Serializable
data class PushSubscribeRequest(
  val endpoint: String,
  val p256dh: String,
  val auth: String,
)

@Serializable
data class PushTestResponse(val attempted: Int, val delivered: Int)
